module.exports = __webpack_public_path__ + "img/drink.05224e49.png";